import { __assign } from "tslib";
// List of downgrades in descending order of versionToDowngradeFrom
// These downgrades are applied sequentially to downgrade a hub config to a lower version compatible with older versions of the App SDK
var downgradeChain = [
    {
        versionToDowngradeFrom: 2,
        downgradeToPreviousVersion: function (higherVersionHubConfig) {
            var _a, _b, _c, _d, _e;
            return {
                apiVersion: 1,
                supports: __assign(__assign({}, higherVersionHubConfig.supports), { dialog: higherVersionHubConfig.supports.dialog
                        ? {
                            bot: (_c = (_b = (_a = higherVersionHubConfig.supports) === null || _a === void 0 ? void 0 : _a.dialog) === null || _b === void 0 ? void 0 : _b.url) === null || _c === void 0 ? void 0 : _c.bot,
                            card: (_d = higherVersionHubConfig.supports.dialog) === null || _d === void 0 ? void 0 : _d.card,
                            update: (_e = higherVersionHubConfig.supports.dialog) === null || _e === void 0 ? void 0 : _e.update,
                        }
                        : undefined }),
            };
        },
    },
];
/**
 * Downgrades a hub config to the newest version that is compatible with the target version of the App SDK.
 */
export var downgradeHubConfig = function (hubConfig, targetVersion, downgrades) {
    if (downgrades === void 0) { downgrades = downgradeChain; }
    if (hubConfig.apiVersion <= targetVersion) {
        return hubConfig;
    }
    var downgradedHubConfig = hubConfig;
    for (var _i = 0, downgrades_1 = downgrades; _i < downgrades_1.length; _i++) {
        var downgrade = downgrades_1[_i];
        if (downgradedHubConfig.apiVersion === downgrade.versionToDowngradeFrom) {
            downgradedHubConfig = downgrade.downgradeToPreviousVersion(downgradedHubConfig);
        }
        if (downgradedHubConfig.apiVersion <= targetVersion) {
            break;
        }
    }
    return downgradedHubConfig;
};
//# sourceMappingURL=hub-config.js.map